<template>
	<div>
		<div class="exception-page">
			<div class="img">
				<img src="https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg" />
			</div>
			<div class="content">
				<h1>404</h1>
				<div class="desc">抱歉，你访问的页面不存在或仍在开发中</div>
				<div class="action">
					<el-button type="primary" @click="backHome">返回首页</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
	export default {
		name: 'exp404',
		data() {
			return {
				isPhone:false
			}
		},
		metaInfo() {
			site_name().then(res => {
                document.title = '404-' + res.site_name;
                return {
                    title: '404-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        {
                            name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
                        }
                    ],
                }
            });
		},
		created() {

		},
		methods: {
			backHome() {
				this.$router.push('/');
			},
		}
	}
</script>

<style scoped>
	.exception-page {
		margin-top: 100px;
		border-radius: 4px;
		background-color: #fff;
	}

	.exception-page .img {
		text-align: center;
		display: inline-block;
	}

	.exception-page .img img {
		width:50%;
	}
	.content{
		width: 100%;
		text-align: center;
	}
	.content h1 {
		color: #434e59;
		font-size: 72px;
		font-weight: 600;
		line-height: 72px;
		margin-bottom: 24px;
	}

	.content .desc {
		color: rgba(0, 0, 0, .45);
		font-size: 20px;
		line-height: 28px;
		margin-bottom: 16px;
	}
</style>